var render, staticRenderFns
import script from "./resize-auto.vue?vue&type=script&lang=js"
export * from "./resize-auto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5f6514')) {
      api.createRecord('3f5f6514', component.options)
    } else {
      api.reload('3f5f6514', component.options)
    }
    
  }
}
component.options.__file = "src/components/common/resize-auto.vue"
export default component.exports